import { StampCondition, StampType, StampGrade, StampCancel, StampFormat, StampHinged, StampCentering, StampGumCondition, StampPurchaseCondition, YesNoState } from './constants';
import typeHints from './typeHints';

const attributes = {

  s_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },

  s_category: {
    friendly: 'Category',
    validations: {
      maxLength: 150,
    },
  },

  s_topic: {
    friendly: 'Topic',
    validations: {
      maxLength: 150,
    },
  },

  s_type: {
    friendly: 'Type',
    validations: {
      type: 'enum',
      enumType: StampType,
    },
  },

  s_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: StampCondition,
    },
  },

  s_grade: {
    friendly: 'Grade',
    validations: {
      type: 'enum',
      enumType: StampGrade,
    },
  },

  s_series: {
    friendly: 'Series',
    validations: {
      maxLength: 200,
    },
  },

  s_denomination: {
    friendly: 'Denomination',
    validations: {
      maxLength: 100,
    },
  },

  s_year_produced: {
    friendly: 'Year Produced',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  s_variety: {
    friendly: 'Variety',
    validations: {
      maxLength: 150,
    },
  },

  s_amount_issued: {
    friendly: 'Amount Issued',
    validations: {
      maxLength: 100,
    },
  },

  s_date_issued: {
    friendly: 'Date Issued',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  s_location_issued: {
    friendly: 'Location Issued',
    validations: {
      maxLength: 150,
    },
  },

  s_engraved_by: {
    friendly: 'Designer/Engraver',
    validations: {
      maxLength: 150,
    },
  },

  s_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 150,
    },
  },

  s_perforations: {
    friendly: 'Perforations',
    validations: {
      maxLength: 100,
    },
  },

  s_color: {
    friendly: 'Color',
    validations: {
      maxLength: 150,
    },
  },

  s_print_method: {
    friendly: 'Print Method',
    validations: {
      maxLength: 150,
    },
  },

  s_printer: {
    friendly: 'Printer',
    validations: {
      maxLength: 150,
    },
  },

  s_paper: {
    friendly: 'Paper',
    validations: {
      maxLength: 150,
    },
  },

  s_watermark: {
    friendly: 'Watermark',
    validations: {
      maxLength: 150,
    },
  },

  s_gum: {
    friendly: 'Gum',
    validations: {
      maxLength: 150,
    },
  },

  s_theme: {
    friendly: 'Theme',
    validations: {
      maxLength: 200,
    },
  },

  s_description: {
    friendly: 'Description',
    validations: {
      maxLength: 200,
    },
  },


  s_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: StampPurchaseCondition,
    },
  },

  s_format: {
    friendly: 'Format',
    validations: {
      type: 'enum',
      enumType: StampFormat,
    },
  },

  s_hinged: {
    friendly: 'Hinged',
    validations: {
      type: 'enum',
      enumType: StampHinged,
    },
  },

  s_centering: {
    friendly: 'Centering',
    validations: {
      type: 'enum',
      enumType: StampCentering,
    },
  },

  s_cancel: {
    friendly: 'Cancel',
    validations: {
      type: 'enum',
      enumType: StampCancel,
    },
  },

  s_gum_condtition: {
    friendly: 'Gum Condition',
    validations: {
      type: 'enum',
      enumType: StampGumCondition,
    },
  },

  s_defects: {
    friendly: 'Defects',
    validations: {
      maxLength: 350,
    },
  },

  s_scott_no: {
    friendly: 'Scott #',
    validations: {
      maxLength: 50,
    },
  },

  s_michel_no: {
    friendly: 'Michel #',
    validations: {
      maxLength: 50,
    },
  },

  s_yvert_no: {
    friendly: 'Yvert #',
    validations: {
      maxLength: 50,
    },
  },

  s_stanley_gibbons: {
    friendly: 'Stanley Gibbons #',
    validations: {
      maxLength: 50,
    },
  },

  s_in_album: {
    friendly: 'Album',
    validations: {
      type: 'enum',
      enumType: YesNoState,
    },
  },

  s_album_name: {
    friendly: 'Name',
    validations: {
      maxLength: 150,
    },
  },

  s_page_no: {
    friendly: 'Page',
    validations: {
      maxLength: 150,
    },
  },

  s_row_no: {
    friendly: 'Row',
    validations: {
      maxLength: 150,
    },
  },

  s_col_no: {
    friendly: 'Column',
    validations: {
      maxLength: 150,
    },
  },

};

export default attributes;

export const StampDefaultSplitAttribute = 's_country_of_origin';

export const StampRequiredAttributes = [];

export const StampItemSearchAttributes = ['art_artist_name', 'art_media', 'art_year_produced'];

export const StampOverviewAttributes = ['title', 's_country_of_origin', 's_category', 's_topic', 's_type', 's_year_produced',
  's_condition', 's_grade', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const StampSpecificationAttributes = ['s_denomination', 's_series', 's_variety', 's_color', 's_description',
  's_date_issued', 's_location_issued', 's_dimensions', 's_perforations', 's_watermark', 's_gum', 's_printer', 's_print_method',
  's_paper', 's_engraved_by', 's_theme'];

export const StampPurchaseAttributes = ['purchase_date', 'purchase_price', 's_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const StampDetailAttributes = ['s_format', 's_hinged', 's_centering', 's_cancel', 's_gum_condtition', 's_defects',
  's_michel_no', 's_scott_no', 's_stanley_gibbons', 's_yvert_no'];

export const StampDisplayAttributes = ['s_country_of_origin', 's_category', 's_denomination', 's_series', 's_scott_no', 'tags'];

export const StampSliderGalleryAttributes = {
  titleKey: 's_denomination',
  subtitleKey: 's_series',
};



// WEBPACK FOOTER //
// ./src/config/stampDataAttributes.js